<template>
  <div>
    <custom-callout
      ref="detail-ref"
      class-main="mt-3 rounded"
      :has-toggle="true"
      :opened="data.showTabs"
    >
      <div class="row py-2 mr-md-0 align-items-center">
        <div class="col-md-2" :class="!isMobile ? 'text-center' : ''">
          <div class="d-flex flex-column color-black mb-3">
            <span class="data-title d-block border-mobile text-center">
              Número de Contrato:
            </span>
            <span class="font-16 font-weight-bold">
              {{ data.contractNumber | empty }}
            </span>
          </div>
        </div>
        <div class="col-md-8 border-left">
          <div class="row col-12">
            <div class="col-md-3">
              <span class="data-title d-block border-mobile">Servicio:</span>
            </div>
            <div class="col-md-3">
              <span class="data-title d-block border-mobile">Estudiante:</span>
            </div>
            <div class="col-md-2">
              <span class="data-title d-block border-mobile">Conteo:</span>
            </div>
            <div class="col-md-3">
              <span class="data-title d-block border-mobile">
                Estatus de Firma:
              </span>
            </div>
          </div>
          <div class="row col-12">
            <div class="col-md-3">
              <span class="font-16 color-black">
                {{ data.disciplineName | empty }}
              </span>
            </div>
            <div class="col-md-3">
              <span class="font-16 color-black">
                {{ formatedFullName | empty }}
              </span>
            </div>
            <div class="col-md-2">
              <span class="font-16 color-black">
                {{ data.serviceCount | empty }}
              </span>
            </div>
            <div class="col-md-3">
              <span
                class="font-16 color-black text-break"
                :class="this.data.isElectronicsSignature ? 'mr-2' : ''"
              >
                {{ data.signatureType | empty }}
              </span>
              <div v-if="this.data.isElectronicsSignature" class="d-flex">
                <div
                  class="mr-2"
                  :class="
                    `bg-${statusColor(data.digitalSignatureDocumentStatusId)}`
                  "
                  style="height: 10px !important;
                  width: 10px !important;
                  border-radius: 20px;
                  margin-top: 9px;"
                />
                <span class="font-16 color-black text-break font-weight-bold">
                  {{ data.digitalSignatureDocumentStatus | empty }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-1 border-right">
          <div class="col-md-1">
            <div
              class="col col-md-1 col-12 my-4"
              :class="!isMobile ? 'd-flex justify-content-end p-0' : 'mt-2'"
            >
              <drop-down
                class="mr-3 align-vertical-center
              action-dropdown-background"
                :items="
                  onShowCancelAction(data.digitalSignatureDocumentStatusId)
                    ? actionItems
                    : removeActionItem()
                "
                title="Acciones"
                variant="standard"
              />
            </div>
          </div>
        </div>
        <div class="col-md-1">
          <check-box
            v-model="data.selected"
            class="
                    checkbox
                    d-flex
                    justify-content-center
                    align-items-center
                  "
          />
        </div>
      </div>
      <template #edition>
        <div class="p-2">
          <div class="bg-white p-2">
            <CustomTab
              class="custom-nav-container-result"
              :no-nav-style="false"
            >
              <CustomTabItem
                :active="currentTabIndex === endTermTabs.INFORMACION_ADICIONAL"
                lazy
                title="Información Adicional"
              >
                <AditionalInformation
                  :data="data"
                  :is-evaluation-service="isEvaluationService"
                />
              </CustomTabItem>
              <CustomTabItem
                :active="currentTabIndex === endTermTabs.DOCUMENTOS"
                lazy
                title="Documentos"
              >
                <documents-end-period
                  :academic-year="academicYear"
                  :data="data"
                  @close-tabs="closeTabAction"
                  @on-save-document="handleSaveDocument"
                />
              </CustomTabItem>
              <CustomTabItem
                :active="currentTabIndex === endTermTabs.VISIT_DETAILS"
                lazy
                title="Detalles de Visitas"
              >
                <visit-detail
                  :academic-year="academicYear.id"
                  :ignore-moth-filter="false"
                  :ignore-specialist-filter="false"
                  :item="data"
                  :specialist-id="specialistId"
                  @close-tabs="closeTabAction"
                />
              </CustomTabItem>
              <CustomTabItem
                v-if="data.digitalSignatureDocumentId != null"
                :active="currentTabIndex === endTermTabs.SIGNATURE_DETAIL"
                lazy
                title="Detalles de Firma"
              >
                <signature-detail
                  :contract-id="data.contractId"
                  :data="data"
                  :is-electronic-signature="data.isElectronicsSignature"
                  @close-tabs="closeTabAction"
                  @document-signed="$emit('reload-info')"
                />
              </CustomTabItem>
            </CustomTab>
          </div>
        </div>
      </template>
    </custom-callout>
    <br />
    <validation-observer
      v-if="showCancelElectronicSignature"
      ref="cancelElectronicSignatureForm"
      v-slot="{}"
      tag="form"
    >
      <div class="bg-secondary-9 rounded-lg container-border p-4">
        <div class="row">
          <div class="col-12 mb-1">
            <label class="color-gray-7 font-16 font-weight-bold">
              <i class="fas mr-1 fa-times-circle p-1 color-orange font-18" />
              Cancelación de Firma
            </label>
          </div>
          <div class="col-12 mt-3">
            <label class="data-title mb-0">Razón de Cancelación:</label>
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-text-area
                v-model="reason"
                :count-classes="['float-right']"
                custom-error-msg="La razon es requerida."
                :error="errors[0]"
                :maxlength="3000"
                placeholder="Ingresa razón"
                show-char-count
              />
            </validation-provider>
          </div>
          <div class="col-12 mt-3">
            <div class="d-flex flex-row-reverse bd-highlight w-100 actions">
              <div class="bd-highlight ml-2">
                <action-button
                  i="fas fa-save fa-lg"
                  text="Guardar"
                  variant="success"
                  @click="onSaveCancelElectronicSignature"
                />
              </div>
              <div class="mx-0">
                <action-button
                  i="fas fa-times-circle"
                  text="Cancelar"
                  variant="outline-danger"
                  @click="onCancelElectronicSignature"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>

    <div
      v-if="
        (errorMessages && errorMessages.length) ||
          (!data.hasInterventionPlan && isTherapyService) ||
          (!data.hasProgressInform && data.warningProgressInform)
      "
      class="visit-error-container visit-error-container-mt"
    >
      <error
        v-if="!data.hasInterventionPlan && isTherapyService"
        message="Contrato no cuenta con Plan de Intervención adjuntado."
        variant="no-border"
      />
      <error
        v-if="!data.hasProgressInform && data.warningProgressInform"
        message="Contrato no cuenta con Informe de Progreso anejado."
        variant="no-border"
      />
      <error
        v-for="(error, errorIndex) in errorMessages"
        :key="`validation-container-visit` + errorIndex"
        :message="error"
        variant="no-border"
      />
    </div>
    <div v-if="!data.hasAllParticipants" class="visit-error-container">
      <error
        message="Documento no generado, no cumple con todos los participantes requeridos."
        variant="no-border"
      />
    </div>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import store, { modulesName } from '@/store/index';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import AditionalInformation from './AdditionalInformation.vue';
import DocumentsEndPeriod from './DocumentsEndPeriod.vue';
import servicesTypes from '@/utils/constants/serviceTypes.js';
import disciplineTypes from '@/utils/constants/disciplineTypes.js';
import Error from 'custom-error';
import VisitDetail from '@/views/provider/billing-history-management/components/billDetail/components/VisitDetail.vue';
import { signatureTypeLabels } from '@/utils/constants/signatureTypes';
import SignatureDocumentStatus, {
  SignatureDocumentStatusColor,
} from '@/utils/constants/signatureDocumentStatus.js';
import rpContractDocumentTypes from '@/utils/constants/rpContractDocumentTypes.js';
import objectToFormData from 'object-to-formdata';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';
import { updateVisitSummary as _updateVisitSummary } from '@/services/uspqrp/visit.api.js';
import CheckBox from 'CheckBox';
import SignatureDetail from './SignatureDetail.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import { cancelVisitElectronicsSignature as _cancelVisitElectronicsSignature } from '@/services/uspqrp/visit.api.js';
const END_TERM_TABS = {
  INFORMACION_ADICIONAL: 0,
  DOCUMENTOS: 1,
  VISIT_DETAILS: 2,
  SIGNATURE_DETAIL: 3,
  CANCEL_SIGNATURE: 4,
};

export default {
  name: 'EndTermResultRow',
  components: {
    CustomCallout,
    DropDown,
    CustomTab,
    CustomTabItem,
    Error,
    AditionalInformation,
    DocumentsEndPeriod,
    VisitDetail,
    CheckBox,
    SignatureDetail,
    ValidationProvider,
    ValidationObserver,
    CustomTextArea,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    academicYear: {
      type: Object,
      default: () => {},
    },
    period: {
      type: Object,
      default: () => {},
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    specialistId: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      currentTabIndex: 2,
      signatureTypeLabels,
      reason: null,
      showCancelElectronicSignature: false,
    };
  },
  computed: {
    formatedFullName() {
      return `${this.data.studentFullName} - ${this.data.studentSieId}`;
    },
    actionItems() {
      const items = [];

      items.push({
        label: 'Información Adicional',
        icon: 'fa fa-info-circle color-green px-1',
        variant: 'outline-success m-2 px-4',
        click: () => this.openTabAction(this.endTermTabs.INFORMACION_ADICIONAL),
      });

      items.push({
        label: 'Añadir Documento',
        icon: 'fas fa-file-plus color-green  px-2',
        variant: 'outline-success m-2 px-4',
        click: () => this.openTabAction(this.endTermTabs.DOCUMENTOS),
      });

      items.push({
        label: '',
        icon: 'fas fa-file-plus color-green  px-2',
        variant: 'outline-success m-2 px-4',
        visible: false,
      });

      items.push({
        label: 'Editar Visitas',
        icon: 'fas fa-file-edit color-green px-2',
        variant: 'outline-success m-2 ',
        visible: this.showEditVisits,
        click: () => this.goToVisitRegistry(),
      });

      items.push({
        label: 'Cambiar Tipo de Firma',
        icon: 'fas fa-exchange-alt color-green px-2',
        variant: 'outline-success m-2',
        class: 'signature-type-main',
        visible: this.showUpdateSignatureType,
        click: () => this.updateSignatureType(),
      });

      items.push({
        label: this.signatureTypeLabel,
        icon: 'px-3 px-signature-type',
        class: 'signature-type-label',
        visible: this.showUpdateSignatureType,
        click: () => this.updateSignatureType(),
      });

      items.push({
        label: 'Detalle de Visitas',
        icon: 'fas fa-user-friends color-green px-1',
        variant: 'outline-success m-2',
        click: () => {
          this.openTabAction(this.endTermTabs.VISIT_DETAILS);
        },
      });

      items.push({
        label: 'Detalle de Firma',
        icon: 'fas fa-list color-green px-1',
        variant: 'outline-success m-2',
        click: () => {
          this.openTabAction(this.endTermTabs.SIGNATURE_DETAIL);
        },
      });

      items.push({
        id: this.endTermTabs.CANCEL_SIGNATURE,
        label: 'Cancelar Firma Electrónica',
        icon: 'fas fa-file-minus color-green px-1',
        variant: 'outline-success m-2',
        visible: this.showCancelDEElectronicSignature,
        click: () => {
          this.showCancelElectronicSignature = true;
        },
      });

      return items;
    },
    isMobile() {
      return store.getters[`${modulesName.appModuleName}/getIsMobileDensity`];
    },
    endTermTabs() {
      return END_TERM_TABS;
    },
    isTherapyService() {
      return this.data?.serviceTypeId === servicesTypes.Therapy;
    },
    isAssistantService() {
      return this.data?.serviceTypeId === servicesTypes.Assistant;
    },
    isEvaluationService() {
      return this.data?.serviceTypeId === servicesTypes.Evaluation;
    },
    isABATherapy() {
      return (
        this.isTherapyService &&
        this.data.therapyService.id === disciplineTypes.TerapiaABA
      );
    },
    hasNotBillOrIsPreliminaryBill() {
      return this.data?.hasNotBillOrIsPreliminaryBill ?? false;
    },
    hasPendingReviewBillAdjustment() {
      return this.data?.hasPendingReviewBillAdjustment ?? false;
    },
    showEditVisits() {
      return (
        (this.isTherapyService || this.isAssistantService) &&
        this.hasNotBillOrIsPreliminaryBill === true &&
        this.hasPendingReviewBillAdjustment === false
      );
    },
    showUpdateSignatureType() {
      return (
        this.hasNotBillOrIsPreliminaryBill === true ||
        (this.hasPendingReviewBillAdjustment === true &&
          this.data.digitalSignatureDocumentStatusId ===
            SignatureDocumentStatus.DocNotGenerated)
      );
    },
    showCancelDEElectronicSignature() {
      return (
        this.hasNotBillOrIsPreliminaryBill === true ||
        (this.hasPendingReviewBillAdjustment === true &&
          this.data.digitalSignatureDocumentStatusId ===
            SignatureDocumentStatus.Signed)
      );
    },
    showContinuedDuration() {
      return this.isAssistantService || this.isABATherapy;
    },
    signatureTypeLabel() {
      return this.data.isElectronicsSignature
        ? `${signatureTypeLabels.Electronic} a ${signatureTypeLabels.Handwritten}`
        : `${signatureTypeLabels.Handwritten} a ${signatureTypeLabels.Electronic}`;
    },
  },
  methods: {
    closeTabAction() {
      this.$refs['detail-ref'].isOpen = false;
      this.currentTabIndex = -1;
    },
    openTabAction(tab = 0) {
      if (!this.$refs['detail-ref'].isOpen) {
        this.$refs['detail-ref'].open();
      }
      this.currentTabIndex = tab;
    },
    goToVisitRegistry() {
      const { companyId, requestServiceId, contractId } = this.data;
      this.$router.push({
        name: 'visitRegistry',
        params: {
          companyId,
          requestServiceId,
          contractId,
          academicYearId: this.academicYear.id,
          disableNavigation: true.toString(),
          month: this.period.monthNumber,
        },
      });
    },
    async updateSignatureType() {
      if (
        this.data.contractIsElectronicSignature === false &&
        this.data.isElectronicsSignature === false
      ) {
        this.ShowToast(
          'Alerta',
          `Para firmar certificación de manera electrónica es requerido que el contrato se firme igual, debe enmendar el mismo para cambio tipo de firma.`,
          'error'
        );
        return;
      }

      if (
        this.data.isElectronicsSignature &&
        [
          SignatureDocumentStatus.InRow,
          SignatureDocumentStatus.InSigningProcess,
          SignatureDocumentStatus.Signed,
        ].includes(this.data.digitalSignatureDocumentStatusId)
      ) {
        this.ShowToast(
          'Alerta',
          `No es posible modificar el tipo de firma ya que cuenta con un documento de Certificación de Visita tramitado para firma electrónica en estatus ${this.data.digitalSignatureDocumentStatus}.`,
          'error'
        );
        return;
      }

      const payload = objectToFormData(
        {
          visitSummaryId: this.data.visitSummaryId,
          isElectronicsSignature: !this.data.isElectronicsSignature,
        },
        { indices: true, nullsAsUndefineds: true }
      );

      try {
        const { data } = await _updateVisitSummary(payload);

        if (data) {
          await this.$emit('reload-info');
          this.ShowToast(
            'Proceso Exitoso',
            `El tipo de firma para esta certificación ha sido cambiado exitosamente.`,
            'success'
          );
        } else {
          this.ShowToast('Alerta', data.errorMessage || 'error', 'error');
          return;
        }
      } catch (err) {
        this.ShowToast('Alerta', err.response?.data?.message, 'error');
      }
    },
    statusColor(statusId) {
      const hashMap = {
        [SignatureDocumentStatus.DocNotGenerated]:
          SignatureDocumentStatusColor[SignatureDocumentStatus.DocNotGenerated],

        [SignatureDocumentStatus.InRow]:
          SignatureDocumentStatusColor[SignatureDocumentStatus.InRow],

        [SignatureDocumentStatus.InSigningProcess]:
          SignatureDocumentStatusColor[
            SignatureDocumentStatus.InSigningProcess
          ],

        [SignatureDocumentStatus.Canceled]:
          SignatureDocumentStatusColor[SignatureDocumentStatus.Canceled],

        [SignatureDocumentStatus.Signed]:
          SignatureDocumentStatusColor[SignatureDocumentStatus.Signed],
      };
      return hashMap[statusId];
    },
    onShowCancelAction(statusId) {
      if (
        [
          SignatureDocumentStatus.InSigningProcess,
          SignatureDocumentStatus.Signed,
        ].includes(statusId)
      ) {
        return true;
      } else {
        return false;
      }
    },
    async onCancelElectronicSignature() {
      this.showCancelElectronicSignature = false;
      this.reason = null;
    },
    async onSaveCancelElectronicSignature() {
      const isFormValid = await this.$refs.cancelElectronicSignatureForm.validate();
      if (isFormValid) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea <b class="text-capitalize">cancelar</b> firma electrónica de contrato ${this.data.contractNumber}?`,
          'Sí',
          'No'
        );
        if (!answer) return;

        const { data: dataCancel } = await _cancelVisitElectronicsSignature(
          this.data.visitSummaryId,
          this.reason
        );

        if (dataCancel) {
          this.ShowToast(
            'Confirmación',
            `Documento para Firma Electrónica cancelado exitosamente.`,
            'success'
          );
          this.onCancelElectronicSignature();
          await this.$emit('reload-info');
        } else {
          this.ShowToast('Alerta', 'Error al cancelar el documento.', 'error');
          return;
        }
      }
    },
    removeActionItem() {
      const actions = this.actionItems.filter(
        (item) => item.id !== this.endTermTabs.CANCEL_SIGNATURE
      );
      return actions;
    },
    handleSaveDocument(documentTypeId) {
      if (
        documentTypeId === rpContractDocumentTypes.InterventionPlan &&
        this.isTherapyService &&
        !this.data.hasInterventionPlan
      ) {
        this.data.hasInterventionPlan = true;
      }
    },
  },
};
</script>

<style lang="scss">
.action-dropdown-background #dropdownMenuButton {
  background-color: transparent !important;
}

.visit-error-container {
  background: #fae7e7;
  padding: 10px;
  border-radius: 0px 0px 5px 5px;
  margin-top: -16px;
  margin-bottom: 20px;
}

.visit-error-container-mt {
  margin-top: 0.01rem !important;
}

.px-signature-type {
  padding-left: 1.25rem !important;
}

.signature-type-main {
  margin-bottom: -0.75rem !important;
}

.signature-type-label {
  font-weight: bold;
}

.dropdown .show:hover .signature-type-main {
  color: #16181b;
  text-decoration: none;
  background-color: #e9ecef;
}

.dropdown .show:hover .signature-type-label {
  color: #16181b;
  text-decoration: none;
  background-color: #e9ecef;
}
</style>
